module.exports = __webpack_public_path__ + "static/media/wix.bfc7bebf.svg";